import React, { useContext, useRef, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import OTPInputField from "../../../../components/common/inputFields/OTPInputField";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../context/authContext";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../context/userContext";

const PhoneSignin2 = ({ handleSteps, handleSendOtp }) => {
  const otpFieldRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const { fetchUserInfo } = useUser();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const handleResendOtp = () => {
    handleSendOtp(otpFieldRef);
    // otpFieldRef.current?.resetTimer();
  };

  const verifyOtp = async (num, accessToken) => {
    const formData = new FormData();
    formData.append("phone_number", num);
    formData.append("verification", accessToken);
    try {
      const response = await AuthApi.verifyOtp(formData);
      {
        if (response.code === 200) {
          if (response?.data?.access_token) {
            login(response?.data?.access_token);
            toast.success(t("login_success"));
            fetchUserInfo();
            navigate("/dashboard");
          }
        }
        if (response.code === 100 || response.code === 204) {
          toast.error(response.message);
        }
        if (response.code === 400) {
          toast.error(response.error);
        }
      }
    } catch (error) {}
  };

  const onSubmit = async (data) => {
    const otp = Object.values(data).join("");
    try {
      setLoading(true);
      const confirmationResult = window.confirmationResult;
      const result = await confirmationResult.confirm(otp);
      const user = result.user;
      verifyOtp(user.phoneNumber, user.accessToken);
    } catch (error) {
      toast.error(t("invalid_expired_otp"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Box className="mb-4">
        <HeadingStyled size="24px" weight="bold" color="var(--text)">
          {t("we_just_texted_you")}
        </HeadingStyled>
        <TextStyled size="16px" color="var(--text2)">
          {t("enter_the_code_we_sent_you")}
        </TextStyled>
      </Box>
      <Box>
        <Box>
          <OTPInputField
            ref={otpFieldRef}
            register={register}
            setValue={setValue}
          />
          <FormButtonStyled
            label={t("sign_in")}
            color="var(--white)"
            bg="var(--themeColor)"
            className="w-100"
            clName="w-100 my-4"
            type="submit"
            isLoading={loading}
          />
        </Box>
        <Box className="d-flex justify-content-end">
          <Box>
            <TextStyled color="var(--text2  )" size="16px" weight="500">
              {t("did_not_receive_otp")}
              &emsp;
              <SpanStyled
                className="cursor-pointer"
                color="var(--themeColor)"
                size="16px"
                weight="700"
                onClick={handleResendOtp}
              >
                {t("resend")}
              </SpanStyled>
            </TextStyled>
          </Box>
        </Box>
      </Box>
    </Form>
  );
};

export default PhoneSignin2;
